import { Component, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  NbButtonModule,
  NbCardModule,
  NbDialogRef,
  NbIconModule,
  NbInputModule,
  NbToastrService
} from '@nebular/theme';
import { Subject, takeUntil } from 'rxjs';
import { InsightWebSocketService } from 'src/app/core/services/web-socket.service';
import { InsightService } from '../../services/insight.service';

@Component({
  selector: 'app-insight-terminate-modal',
  templateUrl: './insight-terminate-modal.component.html',
  styleUrls: ['./insight-terminate-modal.component.css'],
  imports: [NbCardModule, NbIconModule, NbButtonModule, NbInputModule, FormsModule]
})
export class InsightTerminateModalComponent implements OnDestroy {
  private unsubscribe = new Subject<void>();

  public title: string;
  public message: string;
  public yesButton = $localize`Yes`;
  public noButton = $localize`No`;
  public reasonText = '';
  public job_id: string;
  public insight_name: string;

  constructor(
    protected ref: NbDialogRef<InsightTerminateModalComponent>,
    private service: InsightService,
    private socketService: InsightWebSocketService,
    private toastrService: NbToastrService
  ) {}

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public clickedYes() {
    if (this.job_id) {
      this.service
        .terminateInsightJob(this.job_id, this.reasonText)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((data) => {
          if (data.message === 'successful') {
            this.socketService.closeWindow(data.job_id);
            this.ref.close(true);
          } else {
            this.toastrService.show(
              status,
              $localize`Terminating Insight: ${this.insight_name}'s Job: ${this.job_id} Failed`,
              {
                status: 'danger'
              }
            );
          }
        });
    } else {
      this.toastrService.show(status, $localize`Could not find Job ID, try refreshing the Insights Table.`, {
        status: 'danger'
      });
    }
  }

  public clickedNo() {
    this.ref.close(false);
  }
}
